import { ErrorMessage } from '@lightspeed/design-system-react'
import { useT } from '@transifex/react'
import React from 'react'
import { useAppSelector } from '../../../../state/hooks'
import { selectAutoTaxAddressError } from '../../../../state/slices/currentSale/currentSaleSlice'
import { CalculateTaxErrorTypes } from '../../../../queries/calculate-tax'

const ADDRESS_ERROR_CONTEXT = 'Sale Line Item Expanded > Fulfilment Address'

interface AutotaxErrorsProps {
  countryId: string | undefined
}

export const AutotaxErrors: React.FC<AutotaxErrorsProps> = ({ countryId }) => {
  const t = useT()
  const autoTaxAddressError = useAppSelector(selectAutoTaxAddressError)
  const isUS = countryId === 'US'

  const zipCodeTOptions = {
    _key: 'sale.line-item-expanded.fulfilment-address.zip-postal-code',
    _context: ADDRESS_ERROR_CONTEXT,
  }
  const stateProvinceTOptions = {
    _key: 'sale.line-item-expanded.fulfilment-address.state-province',
    _context: ADDRESS_ERROR_CONTEXT,
  }

  if (
    !autoTaxAddressError ||
    autoTaxAddressError !== CalculateTaxErrorTypes.POSTCODE_NOT_IN_STATE
  ) {
    return null
  }

  return (
    <ErrorMessage>
      {t(
        'Selected {zipOrPostalCode} and {stateOrProvince} do not match. Update them to enable automatic tax calculation.',
        {
          zipOrPostalCode: isUS
            ? t('ZIP code', zipCodeTOptions)
            : t('postal code', zipCodeTOptions),
          stateOrProvince: isUS
            ? t('state', stateProvinceTOptions)
            : t('state/province', stateProvinceTOptions),
          _key: 'sale.line-item-expanded.fulfilment-address.error',
          _context: ADDRESS_ERROR_CONTEXT,
        }
      )}
    </ErrorMessage>
  )
}
